

import Previewer from 'vux/src/components/previewer/index.vue'

import wx from 'wx'
import Divider from 'vux/src/components/divider/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { videoPlayer } from 'vue-video-player'
import configInfo from '../configInfo'

export default{
props: {
eventHub: Object
},
directives: {
TransferDom
},
components: {
Divider,
XDialog,
XButton,
Group,
XSwitch,
Previewer,
videoPlayer,
wx
},
created(){
this.matchId = this.$route.query.matchId;
},
mounted(){

this.initTab();
},
data(){
return {
currentOrgCode: configInfo.orgCode,
matchId: '',//352917
content: '精彩瞬间',
indexContentHeight: 0,
assets: [],
imagelist: [],
videolist: [],
defaultImg: 'this.src="' + require('../assets/img/no_pic.png') + '"',
videoTag: require('../assets/img/video.svg'),
showHideOnBlur: false,
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


},
},
playerOptions: {

playbackRates: [0.5, 1.0, 2.0],
sources: [{
type: "video/mp4",
src: ""
}],

autoplay: true, //如果true,浏览器准备好时开始回放。
muted: false, // 默认情况下将会消除任何音频。
loop: false, // 导致视频一结束就重新开始。
preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
language: 'zh-CN',
aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
width: document.documentElement.clientWidth,
notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
controlBar: {
timeDivider: true,
durationDisplay: true,
remainingTimeDisplay: false,
fullscreenToggle: true  
}
}
}
},
methods: {
initTab(){
this.$nextTick(() => {
this.indexContentHeight = document.body.clientHeight;
})

this.hagkHttp(this.hagkApi.getMatchAssetsByMatchId(this.matchId, 'moment'), {})
.then((res) => {
this.videolist.splice(0, this.videolist.length);
this.imagelist.splice(0, this.imagelist.length);
this.assets.splice(0, this.assets.length);
if (res && res.length > 0) {
for (var i = 0; i < res.length; i++) {
for (var j = 0; j < res[i].assetList.length; j++) {
var data = {};
data.url = this.hagkApi.getImgAssetById(res[i].assetList[j].assetId).url;
data.thumbnail_url = this.hagkApi.getImgAssetById(res[i].assetList[j].thumbnailId).url;
data.type = res[i].assetList[j].type;
data.description = res[i].assetList[j].description
this.assets.push(data)
}
}

for (var i = 0; i < this.assets.length; i++) {
var data = {};
if (this.assets[i].type == "video") {
data.src = this.assets[i].thumbnail_url;
data.actSrc = this.assets[i].url;
data.type = "video"
data.description = this.assets[i].description
this.videolist.push(data)
} else {
data.src = this.assets[i].url;
data.actSrc = this.assets[i].url;
data.type = this.assets[i].type;
data.description = this.assets[i].description
this.imagelist.push(data)
}
}
}
this.changeMomentHeight();
}, (error) => {

});
},
player() {
return this.$refs.videoPlayer.player
},
onPlayerPlay(player) {
},
onPlayerPause(player) {
},
onPlayerWaiting(player) {

},
onPlayerEnded(player) {

},
onPlayerPlaying(player) {

},
onPlayerLoadeddata(player) {

},
onPlayerTimeupdate(player) {

},
onPlayerCanplay(player) {

},
onPlayerCanplaythrough(player) {

},
playerStateChanged(playerCurrentState) {
},
playerReadied(player) {
console.log('the player is readied', player)

},
showImage (src) {
var urls = [];
for(var i=0;i<this.imagelist.length;i++){
urls.push(this.imagelist[i].src);
}
wx.previewImage({
current: src,
urls: urls
})
},
showVideo (index) {







if (this.videolist[index].type == "video") {
this.showHideOnBlur = true;
this.playerOptions.sources.src = this.videolist[index].actSrc;

this.player().reset();
this.player().src({type: "video/mp4", src: this.videolist[index].actSrc});


this.player().play();
}
},
changeMomentHeight(){
if(this.eventHub){
this.eventHub.$emit("resetView");
}

}
}
}



// WEBPACK FOOTER //
// ./src/views/matchMoments.vue